<template>
  <div style="padding-top:50px;">
    <base-search-select v-model="form.sys_client_name" label="客户名称：" @change="onClientSelectChange" />
    <br><br><br>
    <div style="text-align:center">
      <base-button size="middle" @click="onClickBtn">&nbsp;&nbsp;&nbsp;&nbsp;查询客户是否在服务中&nbsp;&nbsp;&nbsp;&nbsp;</base-button>
      <div id="info">温馨提示：此功能仅限管理人员使用</div>
    </div>
    <template v-if="is_show_info">
      <br><br><br><br>
      <div style="text-align:center;">【{{ curr_client_name }}】<br> <span :style="{color: is_in_service ? 'red' : 'green'}">{{ is_in_service ? '' : '不' }}是服务中客户</span></div>
    </template>
  </div>
</template>

<script>
import { ServiceDict } from '@/api/service';
import { getCurrentDate } from '@/api/commons';
import { Toast } from 'vant';
export default {
  name: 'ClientInServiceQuery',
  data() {
    return {
      form: {
        client_id: null,
        sys_client_name: null,
        product_id: 1,
        begin_end_date: null
      },
      curr_client_name: null,
      is_in_service: null,
      is_show_info: null
    };
  },
  created() {
    this.setCurrentDate();
  },
  methods: {
    setCurrentDate() {
      this.form.begin_end_date = this.$store.getters.currentDate;
      if (!this.form.begin_end_date) {
        getCurrentDate().then(resp => {
          if (resp.success) {
            this.form.begin_end_date = resp.obj.curr_date;
          }
        });
      }
    },
    onClientSelectChange(name, value) {
      if (value) {
        this.is_show_info = false;
        this.form.client_id = value.id;
        this.curr_client_name = this.form.sys_client_name;
      }
    },
    isValid() {
      if (this.form.client_id) {
        return true;
      }
    },
    onClickBtn() {
      if (!this.isValid()) {
        Toast.fail('无效客户名');
        return;
      }
      ServiceDict(this.form).then(resp => {
        if (resp.success) {
          if (resp.rows && resp.rows.length) {
            this.is_in_service = true;
          } else {
            this.is_in_service = false;
          }
          this.is_show_info = true;
        } else {
          this.error(this.CONST.TIP.COMMON_ERROR);
        }
      });
    }
  }
};
</script>
<style scoped>
#info {
  font-size: 14px;
  padding-top: 10px;
  color: rgb(196, 198, 198);
}
</style>



// WEBPACK FOOTER //
// src/components/client-in-service/query.vue